"use client";

import { Link } from "react-router-dom";
import cn from "../../../../isomorphic-core/src/utils/class-names";
import SimpleBar from "../../../../isomorphic-core/src/ui/simplebar";
import { SidebarMenu } from "./sidebar-menu";

export default function Sidebar({ className }: { className?: string }) {
  return (
    <aside
      className={cn(
        "fixed bottom-0 start-0 z-50 h-full w-[270px] border-e-2 border-gray-100 bg-white dark:bg-gray-100/50 2xl:w-72",
        className
      )}
    >
      <div className="sticky top-0 z-40 bg-gray-0/10 px-6 pb-3 pt-3 dark:bg-gray-100/5 2xl:px-8 2xl:pt-6">
        <Link
          to={"/"}
          aria-label="Site Logo"
          className="text-gray-800 hover:text-gray-900"
        >
          <img src={"/owo2.svg"} alt="owoHq logo" width={40} height={0} />
        </Link>
      </div>

      <SimpleBar className="h-[calc(100%-80px)]">
        <SidebarMenu />
      </SimpleBar>
    </aside>
  );
}
